import './App.css';
import { Sidebar, Body, Header } from './Components/index';
import {AboutMe} from "./Pages";
import {Button, ButtonGroup} from "react-bootstrap";
import {useEffect, useState} from "react";
import {Resume} from "./Components";

function App() {

    const [resumeActive, setResumeActive] = useState(false);
    const [aboutActive, setAboutActive] = useState(false);
    const active = {
        resume: false,
        about: false
    }

    const setActiveStateForResume = () => {
        setResumeActive(true);
        setAboutActive(false);
    }

    const setActiveStateForAboutMe = () => {
        setResumeActive(false);
        setAboutActive(true);
    }

    useEffect(() => {

    }, [active.resume, active.about])

    const homeBody = (
        <div className="container-fluid">
            <div className="row flex-nowrap">
                <Header />
            </div>
        </div>
    );

  return (
    <div className="App">
        <div className="container-fluid">
            <div className="row flex-nowrap">
                <Header />
                <Body />
            </div>
        </div>
    </div>
  );
}

export default App;
